export enum ChangeLogGroups {
  FieldAdded = 'FIELD_ADDED',
  FieldRemoved = 'FIELD_REMOVED',
  FieldEdited = 'FIELD_EDITED',
  FieldToggled = 'FIELD_TOGGLED',
  FieldRequired = 'FIELD_MARKED',
  FieldReordered = 'FIELD_REORDERED',
  FieldRevealed = 'FIELD_REVEALED',
  SensitiveConfigAdded = 'SENSITIVE_CONFIG_ADDED',
  SensitiveConfigEdited = 'SENSITIVE_CONFIG_EDITED',
  SensitiveConfigRemoved = 'SENSITIVE_CONFIG_REMOVED',
  SensitiveConfigRevealed = 'SENSITIVE_CONFIG_REVEALED',
  UserRegistrationSuccess = 'USER_REGISTRATION_SUCCESS',
  StatusChanged = 'STATUS_CHANGED',
  FieldEditedFor = 'FIELD_EDITED_FOR',
  FieldAddedFor = 'FIELD_ADDED_FOR',
  FormBuilderFieldAdded = 'FORM_BUILDER_FIELD_ADDED',
  FormBuilderFieldPositionChanged = 'FORM_BUILDER_FIELD_POSITION_CHANGED',
  FormBuilderFieldRequiredToggled = 'FORM_BUILDER_FIELD_REQUIRED_TOGGLE',
  FormBuilderFieldRemoved = 'FORM_BUILDER_FIELD_REMOVED',
  FieldEditedWithOption = 'FIELD_EDITED_WITH_OPTION',
  FieldToggledWithOption = 'FIELD_TOGGLED_WITH_OPTION',
  UserStatusChanged = 'USER_STATUS_CHANGED',
  FieldAddedForProviderWithMethods = 'FIELD_ADDED_FOR_PROVIDER_WITH_METHODS',
  SensitiveConfigAddedForProviderWithMethods = 'SENSITIVE_CONFIG_ADDED_FOR_PROVIDER_WITH_METHODS',
  FieldEditedForProviderWithMethods = 'FIELD_EDITED_FOR_PROVIDER_WITH_METHODS',
  FieldRemovedForPoviderWithMethods = 'FIELD_REMOVED_FOR_PROVIDER_WITH_METHODS',
  SensitiveConfigEditedForProviderWithMethods = 'SENSITIVE_CONFIG_EDITED_FOR_PROVIDER_WITH_METHODS',
  SensitiveConfigRemovedForProviderWithMethods = 'SENSITIVE_CONFIG_REMOVED_FOR_PROVIDER_WITH_METHODS',
  MultipleChanged = 'MULTIPLE_CHANGED',
  LicenseAdded = 'LICENSE_ADDED',
  LicenseUpdated = 'LICENSE_UPDATED',
  LicenseRemoved = 'LICENSE_REMOVED',
  ContactChannelAdded = 'CONTACT_CHANNEL_ADDED',
  ContactChannelsLinkUpdated = 'CONTACT_CHANNELS_LINK_UPDATED',
  OperatorRegionalSettingsChanged = 'OPERATOR_REGIONAL_SETTINGS_CHANGED',
  OperatorRegionalSettingsListChanged = 'OPERATOR_REGIONAL_SETTINGS_LIST_CHANGED',
  OperatorPauseStatusChanged = 'OPERATOR_PAUSE_STATUS_CHANGED',
}
